import { render, staticRenderFns } from "./FPotensiSpasialDialog.vue?vue&type=template&id=f502e6e4&scoped=true"
import script from "./FPotensiSpasialDialog.vue?vue&type=script&lang=js"
export * from "./FPotensiSpasialDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f502e6e4",
  null
  
)

export default component.exports